export default function (state = [], action) {
    switch (action.type) {
        case "SELECTED_QUERIES":
            return action.payload;
            break;
        default:
            return state;
    }
}
